import i18next from 'i18next';

/**
 * Displayable channel of a list row. A channel carries a translation key rather than a name, so the
 * label is resolved front-side, the raw name only standing in when the key is missing.
 *
 * @param {Object} externalOrder - A row of the list, flattened by `formatExternalOrders`
 *
 * @returns {string|null} The translated channel, or null when the row carries no channel
 */
export const getExternalOrderChannelLabel = ({ channelName, channelTranslationKey }) => {
  if (!channelName) {
    return null;
  }

  if (!channelTranslationKey) {
    return channelName;
  }

  return i18next.t(`${channelTranslationKey}.FULL`);
};
